// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MoveDownSvg from '@rsuite/icon-font/lib/action/MoveDown';
var MoveDown = createSvgIcon({
  as: MoveDownSvg,
  ariaLabel: 'move down',
  category: 'action',
  displayName: 'MoveDown'
});
export default MoveDown;